<template>
  <div class="selectFuncRoom">
    <el-tooltip class="item" effect="light" :disabled="(funcRoomName ? false : true)" :content="funcRoomName" placement="top"
      :style="{width: myWidth}">
      <el-autocomplete highlight-first-item class="inline-input" :style="{width: myWidth}" v-model="funcRoomName" :readonly="inputDis" :size="size"
        clearable @clear="reset" :fetch-suggestions="querySearch" placeholder="输入 地址/简拼/电话 查找" @select="selectFuncRoom"
        @change="changeFuncRoomName" :trigger-on-focus="false">
        <template slot-scope="{ item }">
          <el-tooltip effect="light" :content="item.value" placement="top">
            <div>{{ item.value }}</div>
          </el-tooltip>
        </template>
        <!-- <el-button slot="append" icon="el-icon-close" @click="reset"></el-button> -->
        <!-- <el-button slot="append" icon="el-icon-plus" @click="alertDialog"></el-button> -->
      </el-autocomplete>
    </el-tooltip>
    <el-dialog title="选择功能间" :visible.sync="dialogVisible" width="800px" append-to-body :show-close="false">
      <el-input v-model="search" placeholder="查找功能间名称/电话/位置"></el-input>
      <el-table ref="selectFuncRoomTable" highlight-current-row :data="tables" tooltip-effect="dark" style="width: 100%"
        @row-click="rowClick" @row-dblclick="toSure" v-scrollBar:tableArg height="280px" v-loading="loading">
        <el-table-column label="功能间名称" width="250">
          <template slot-scope="scope">{{ scope.row.NAME }}</template>
        </el-table-column>
        <el-table-column label="功能间电话" width="150">
          <template slot-scope="scope">{{ funcRoomPhone(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="功能间位置" show-overflow-tooltip width="300">
          <template slot-scope="scope">{{ locationName(scope.row) }}</template>
        </el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 20px;">
        <el-button @click="toClose">关闭</el-button>
        <el-button type="primary" @click="toSure">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  function hasVal(val) {
    return (val ? val : '')
  }
  import {
    GetFuncRoomByCompanyId
  } from '@/api/modules/basicData/organization'
  export default {
    name: 'selectfuncRoom',
    data() {
      return {
        dialogVisible: false,
        funcRoomDataStay: null,
        funcRoomData: null,
        funcRoomNameStay: '',
        funcRoomName: '',
        loading: false,
        locationName(room) {
          return (hasVal(room.AreaName) + hasVal(room.BuildingName) + hasVal(room.StoreyName) + hasVal(room.RoomName))
        },
        simpleLocationName(room) {
          return (hasVal(room.BuildingName) + hasVal(room.StoreyName) + hasVal(room.RoomName))
        },
        funcRoomPhone(room) {
          return (room.ListPhones && room.ListPhones.length > 0) ? room.ListPhones[0].FIXEDPHONE : ''
        },
        search: '',
        tableData: [],
        allLinkData: [],
        myWidth: '',
        userName: '',
        inputDis: false,
      }
    },
    props: {
      setWidth: {
        type: String,
        default: ''
      },
      isValidateMethod: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: ''
      },
      idArray: {
				type: Array,
				default: function() {
					return []
				}
			},
    },
    created() {
      this.myWidth = this.setWidth;
    },
    computed: {
      tables() {
        const search = this.search
        if (search) {
          return this.allLinkData.filter(dataNews => {
            var NAME = dataNews.NAME;
            var location = this.locationName(dataNews);
            var phone = this.funcRoomPhone(dataNews);
            return ((NAME.indexOf(search) > -1) || location.indexOf(search) > -1 || phone.indexOf(search) > -1)
          })
        }
        return this.tableData
      }
    },
    methods: {
      changeFuncRoomName(value) {
        this.funcRoomData = null; // 自己修改了功能间名称
      },
      outFuncRoomName(row) {
        return `[${row.NAME},电话:${this.funcRoomPhone(row)}]${this.locationName(row)}`
      },
      alertDialog() { // 弹出主窗体
        this.dialogVisible = true;
        this.loading = true;
        if (this.allLinkData.length > 0) {
          this.loading = false;
        } else {
          GetFuncRoomByCompanyId("", "").then(res => {
            this.allLinkData = res;
            this.tableData = res.slice(0, 250)
            this.loading = false;
          })
        }
        if (this.$refs.selectFuncRoomTable && !this.funcRoomData) {
          this.$refs.selectFuncRoomTable.setCurrentRow();
        }
        this.funcRoomDataStay = null;
        this.funcRoomNameStay = '';
      },
      rowClick(row) {
        this.funcRoomDataStay = row;
        this.funcRoomNameStay = this.outFuncRoomName(row);
      },
      querySearch(queryString, cb) {
        var result = [];
        GetFuncRoomByCompanyId("", queryString).then(res => {
          var resList = res.slice(0, 100).map((a) => {
            return Object.assign(a, {
              value: (`${a.NAME},电话:${this.funcRoomPhone(a)}(${this.simpleLocationName(a)})`)
            })
          })
          cb(resList);
          this.funcRoomDataStay = null;
          this.funcRoomNameStay = '';
        })
      },
      reset() { //叉叉
        this.funcRoomData = null;
        this.funcRoomName = '';
      },
      toClose() { //取消
        this.dialogVisible = false
      },
      selectFuncRoom(item) {
        this.funcRoomData = item;
        this.funcRoomName = this.outFuncRoomName(item);
        this.$emit("getValue", [item])
      },
      toSure() { //确定
        if (this.funcRoomNameStay && this.funcRoomDataStay) {
          this.funcRoomName = this.funcRoomNameStay;
          this.funcRoomData = this.funcRoomDataStay;
          this.$emit("getValue", [this.funcRoomData])
          this.dialogVisible = false;
        } else {
          this.$message.error('请先选中一个功能间!');
        }
      },
    },
    watch: {
      idArray(val){
        if(val.length>0){
          let funcFoom=this.allLinkData.filter(item=>item.ID=val[0]);
          if(funcFoom.length>0){
            this.selectFuncRoom(funcFoom[0])
          }
        }
      },
      deep:true
    },
  }
</script>

